import { Button, ButtonProps, makeStyles, Theme } from '@material-ui/core'
import ShowToRoleAndStates from 'components/Common/Portal/ShowToRole'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { ShowNewProjectForm } from 'store/Application/appActions'
import { useAppDispatch } from 'store/configureStore'
import { useOrganizationContext } from 'utils/useOrganizationContext'

export const useNavbarButtonClasses = makeStyles((theme: Theme) => ({
  buttonCallToAction: {
    flex: '0 0 auto',
    minHeight: 0,
    fontWeight: 'bold',
    color: theme.palette.success.main,
  },
  button: {
    flex: '0 0 auto',
    minHeight: 0,
    fontWeight: 'normal',
    color: 'inherit',
  },
}))

export const NewProjectButton = (props: ButtonProps) => {
  const dispatch = useAppDispatch()
  const classes = useNavbarButtonClasses()

  const { isBuyingParty } = useOrganizationContext()

  const handleOpenNewProject = (isSellerRole: boolean) => {
    dispatch(ShowNewProjectForm(true, isSellerRole))
  }

  return (
    <>
      <ShowToRoleAndStates seller isBuyerRole={isBuyingParty}>
        <Button
          {...props}
          onClick={() => handleOpenNewProject(true)}
          name="new-quotation-button"
          className={classes.buttonCallToAction}
        >
          <LocalizedTypography
            translationKey={'project:new-quotation'}
            translationDefaultValue="new quotation"
          />
        </Button>
      </ShowToRoleAndStates>
      <ShowToRoleAndStates buyer isBuyerRole={isBuyingParty}>
        <Button
          {...props}
          onClick={() => handleOpenNewProject(false)}
          color="inherit"
          name="new-quotation-request-button"
          className={classes.buttonCallToAction}
        >
          <LocalizedTypography
            translationKey={'project:new-quotation-request'}
            translationDefaultValue="new quotation request"
          />
        </Button>
      </ShowToRoleAndStates>
    </>
  )
}
